module.exports = __webpack_public_path__ + "img/reloj-active.01491af0.svg";